import React, { useEffect } from 'react';
import BannerLogo from './assets/images/banner-logo.png';
import './styles/banner.css';

const SectionBanner = () => {

  const scrollToOurStory = () => {
    const target = document.getElementById('section-our-story');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Handle Enter key globally when banner is focused
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Enter key
      if (e.key === 'Enter') {
        scrollToOurStory();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <section className='section-banner comman_sec'>
        <div className='section-wrapper'>
          <div className='banner-content-wrapper'>

            <div className='banner-logo-wrapper'>
              <img src={BannerLogo} alt='banner-logo' />
            </div>

            {/* ENTER BUTTON */}
            <button
              className="enter-btn"
              onClick={scrollToOurStory}
            >
              ENTER
            </button>

            {/* SCROLL ICON */}
            <div
              className='scroll-down-wrapper'
              onClick={scrollToOurStory}
              style={{ cursor: 'pointer' }}
            >
              <div className="scroll-container">
                <div className="scroller"></div>
              </div>
            </div>

          </div>
        </div>
    </section>
  );
};

export default SectionBanner;
